import { GET_PAST_VITALS } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export interface PastVitals {
    status: string;
    data: Data;
}

export interface Data {
    vitalData: { [k: string]: VitalHistory };
    patientProfileData: PatientProfileData;
}

export interface VitalHistory {
    name: string;
    column: DataColumn[];
    values: { [k: string]: string }[];
}

export interface DataColumn {
    key: string;
    val: string;
}

export interface PatientProfileData {
    'is-p': boolean;
    ln: string;
    mobile: string;
    at: string;
    'dob-valid': boolean;
    dob: string;
    fn: string;
    mn?: string;
    uuid: string;
    oid: string;
    gen: string;
}

export default (): Promise<PastVitals> =>
    fetchWithRefresh(GET_PAST_VITALS).then((r) => {
        if (r.status === 200) {
            return r.json();
        } else {
            throw new Error('failed');
        }
    });
